import { Accordion, Box, Flex, Stack, Text, Tooltip } from '@mantine/core'
import React, { useContext, useEffect, useState } from 'react'
import { LIGHT_BLUE_BACKGROUND, LIGHT_GREY_BG, MAIN_DARK_PRIMARY } from '../../../constants/colors'
import { formatBigMonetaryValue } from '../../ideaNiv/Funcs'
import SingleCustomerContext from '../Customer-Context/SingleCustomerContext'
import EvidenceLoader from './EvidenceLoader'
import SideBar from '../../ideaNiv/right-bar/evidence-card/SideBar'
import SyncContext from '../../../context/SyncContext'
import { IconAlertOctagon } from '@tabler/icons'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import { getNestedFieldValue } from '../../ideaNiv/helpers/calculateImpactResults'

const AccordionItem = (
  { 
    customer,
   
    evidences,
    relatedCustomers,
    scrollToElement
  }
  :
  { customer: any,
 
     evidences: any [],
     relatedCustomers: any [],
     scrollToElement: (customerId: string) => void
    }) => {


  const { requestPriorities } = useContext(SyncContext);

  const { fetchSingleCustomerEvidence, chosenIdea, loadingEvidence, setLoadingEvidence, impactAggregationProperties } = useContext(SingleCustomerContext);
  const [isLoading, setIsLoading] = useState(false);

  const evidence = evidences?.find((evidence: any) => evidence?.orgId === customer?._id)

  const mainImpactProperty = impactAggregationProperties?.find((property: any) => property?.impact?.isMainImpact)
  const fieldPath = mainImpactProperty?.fieldPath

  const totalMainImpact = getNestedFieldValue(evidence, fieldPath)
  const mainImpactLabel = mainImpactProperty?.label
  const priority = evidence?.priority

  const priorityObj = requestPriorities.find((priorityItem: any)=> 
    priorityItem?.label?.toLowerCase() === priority?.toLowerCase())

  const color = priorityObj?.color
  const background = priorityObj?.background

  const chooseEvidence = async (orgId: string) => {
    const evidence = evidences?.find((evidence: any) => evidence?.orgId === orgId)
    if (!evidence?._id) return;
    
    setIsLoading(true)
    try {
      await fetchSingleCustomerEvidence(evidence._id)
    } finally {
      setIsLoading(false)
      setLoadingEvidence(false)
    }
  }

  const handleClick = (orgId: string) => {
    chooseEvidence(orgId);
    scrollToElement(orgId);
  }

  useEffect(() => {
    if (chosenIdea) {
      chooseEvidence(customer?._id)
    }
  }, [chosenIdea?._id, customer])

  return (
    <Accordion.Item 
      value={`${customer?._id}-${chosenIdea?._id}`} 
      key={`${customer?._id}-${chosenIdea?._id}`}
      data-customer-id={customer?._id}
    >
      <Accordion.Control  h={68} px={36} onClick={() => handleClick(customer?._id)} bg={LIGHT_GREY_BG}>
        <Flex justify="space-between" align="center">
          <Text fw={600} color={MAIN_DARK_PRIMARY}>{customer?.name || "No Name"}</Text>

          <Flex gap={12} justify='space-between'>
            {priorityObj ?
              <Flex 
                w={120}
                py={4}
                px={8}
                h={24}
                bg={background}
                sx={{borderRadius: 4}}
              >
                <Stack justify='center' mr={4}>
                  <IconAlertOctagon color={color} size={14}  fill={background} />
                </Stack>
                <Text 
                  color={color}
                  fz={12}
                  fw={600}
                >
                  {
                    capitalizeFirstLetter(priority)
                  }
                </Text>
              </Flex> : <Flex w={120}> </Flex>
            }

            {totalMainImpact ? 
              <Flex 
                w={100}
                py={4}
                px={8}
                h={24}
                bg={LIGHT_BLUE_BACKGROUND}
                sx={{borderRadius: 4}}
              >
                <Tooltip label={mainImpactLabel}>
                  <Text fz={12} mr={3} lineClamp={1}>{mainImpactLabel}</Text>
                </Tooltip>
                
                <Text 
                  fz={12}
                  fw={600}
                >{
                    formatBigMonetaryValue(totalMainImpact)}
                </Text>
              </Flex> : <Flex w={100}></Flex>}
          </Flex>
          
              
        </Flex>
      </Accordion.Control>
      <Accordion.Panel p={0}>
        <Box h={ "calc(100vh - 332px)" }>
          {(isLoading || loadingEvidence) ? <EvidenceLoader /> : (
            <SideBar 
              navToPerspective={null} 
              setActiveSearch={null} 
              reviewMode 
              componentType={'customer'}/>
          )}
        </Box>
      </Accordion.Panel>
    </Accordion.Item>
  )
}

export default AccordionItem